export default __webpack_public_path__ + "static/media/uvod.b5fb37ad.png";